import axios from "axios";
import ConfigConnection from "../config/config.service";
export default class ReportService {
  // API Instance
  configConnection: any = new ConfigConnection();

  get() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}user`, config);
  }

  edit(user, user_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.put(
      `${_.configConnection.apiInstance}user/${user_id}`,
      user,
      config
    );
  }

  getById(user_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}user/${user_id}`,
      config
    );
  }

  delete_user(user_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.delete(
      `${_.configConnection.apiInstance}user/${user_id}`,
      config
    );
  }

  getCompanies(company_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}company/${company_id}`,
      config
    );
  }

  assingCompanies(user_id, company_id) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}user/${user_id}/company`,
      { company_id: company_id },
      config
    );
  }

  getInactive() {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(`${_.configConnection.apiInstance}user/inactive`, config);
  }

  active_user(user_id, reactivate) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.get(
      `${_.configConnection.apiInstance}user/${user_id}/reactivate`,
      config
    );
  }

  getProfileReport(userSurveyId, profileId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}user/candidate/${userSurveyId}/report`,
      profileId,
      config
    );
  }

  getSingleReport(userSurveyId) {
    const _ = this;
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tk_auth")}`,
      },
    };
    return axios.post(
      `${_.configConnection.apiInstance}user/${userSurveyId}/report`,
      config
    );
  }
}
